export enum PaginationSize {
  SIZE_1 = 1,
  SIZE_5 = 5,
  SIZE_6 = 6,
  SIZE_8 = 8,
  SIZE_10 = 10,
  SIZE_11 = 11,
  SIZE_12 = 12,
  SIZE_100 = 100,
  SIZE_1000 = 1000,
}
